<template>
  <div class="flex">
    <div
      v-for="(label, index) of ['Temperature', 'Humidity']"
      :key="index"
      class="w-1/2"
      :class="index === 0 ? 'pr-1' : 'pl-1'">
      <div v-if="index === 0 && chartLineTrendVisible0" class="border rounded-md">
        <div class="wrapper w-full hover:bg-gray-100 cursor-pointer" @click="$router.push(`/report/${label}?labelheader=${label}%20Report`)">
          <splide :options="slideOptions" :ref="'splide'+index">
              <splide-slide 
                v-for="dataIndex of dataCollectionLineTrends2[index].length"
                :key="dataIndex"
                class="p-2 ">
                <div class="text-center font-bold mb-1">{{ label }} Trend (every 5 minutes)</div>
                <line-chart
                  style="width: 99%;"
                  :height="200"
                  :chart-data="dataCollectionLineTrends2[index][dataIndex - 1]"
                  :options="chartOptionsLineTrend"
                />
                <div class="flex flex-wrap my-2">
                  <div
                    v-for="(label, index) of getGridLabel(dataCollectionLineTrends2[index][dataIndex - 1])"
                    :key="index"
                    class="w-1/4 flex items-center text-xs font-bold">
                    <div class="h-2 w-2 rounded-full mr-1" :style="`background:${label.backgroundColor}`"></div> {{ label.label }}
                  </div>
                </div>
              </splide-slide>
          </splide>
        </div>
        <div class="flex justify-between px-3 my-1">
          <div class="px-2 border rounded-full cursor-pointer hover:bg-gray-100 text-xs select-none" @click="splidePrev(index)">Prev</div>
          <div class="px-2 border rounded-full cursor-pointer hover:bg-gray-100 text-xs select-none" @click="splideNext(index)">Next</div>
        </div>
      </div>
      <div v-if="index === 1 && chartLineTrendVisible1" class="border rounded-md">
        <div class="wrapper w-full hover:bg-gray-100 cursor-pointer" @click="$router.push(`/report/${label}?labelheader=${label}%20Report`)">
          <splide :options="slideOptions" :ref="'splide'+index">
              <splide-slide 
                v-for="dataIndex of dataCollectionLineTrends2[index].length"
                :key="dataIndex"
                class="p-2 ">
                <div class="text-center font-bold mb-1">{{ label }} Trend (every 5 minutes)</div>
                <line-chart
                  style="width: 99%;"
                  :height="200"
                  :chart-data="dataCollectionLineTrends2[index][dataIndex - 1]"
                  :options="chartOptionsLineTrend"
                />
                <div class="flex flex-wrap my-2">
                  <div
                    v-for="(label, index) of getGridLabel(dataCollectionLineTrends2[index][dataIndex - 1])"
                    :key="index"
                    class="w-1/4 flex items-center text-xs font-bold">
                    <div class="h-2 w-2 rounded-full mr-1" :style="`background:${label.backgroundColor}`"></div> {{ label.label }}
                  </div>
                </div>
              </splide-slide>
          </splide>
        </div>
        <div class="flex justify-between px-3 my-1">
          <div class="px-2 border rounded-full cursor-pointer hover:bg-gray-100 text-xs select-none" @click="splidePrev(index)">Prev</div>
          <div class="px-2 border rounded-full cursor-pointer hover:bg-gray-100 text-xs select-none" @click="splideNext(index)">Next</div>
        </div>
      </div>
      <div v-if="(index === 0 && !chartLineTrendVisible0)" class="border rounded-md" style="height: 330px" v-loading="true"></div>
      <div v-if="(index === 1 && !chartLineTrendVisible1)" class="border rounded-md" style="height: 330px" v-loading="true"></div>
    </div>
  </div>
</template>

<script>
import LineChart from './LineChart.js'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
  components: {
    LineChart,
    Splide,
    SplideSlide
  },
  data() {
    return {
      chartLineTrendVisible0: false,
      chartLineTrendVisible1: false,
      dataCollectionLineTrends: [{}, {}],
      dataCollectionLineTrends2: [[], []],
      chartOptionsLineTrend: {
        plugins: {
          datalabels: {
            display: false
          }
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            boxWidth: 12
          }
        },
        scales: {
          yAxes: [
            {
              gridLines: { color: 'white' }
            }
          ]
        }
      },
      terbagiBerapa: [0, 0],
      slideOptions: {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        isNavigation: false,
        fixedHeight : 330,
      },
      lineTrendChartVisible: [0, 0],
      trendChartColors: [
        '#ef5350',
        '#ec407a',
        '#ab47bc',
        '#5c6bc0',
        '#42a5f5',
        '#29b6f6',
        '#26a69a',
        '#66bb6a',
        '#d4e157',
        '#ffa726'
      ],
      getAndFillDataTrendInterval: null
    }
  },
  computed: {
    location: function () {
      return this.$route.query.location
    }
  },
  watch: {
    location: function (val) {
      setTimeout(() => {
        this.getAndFillDataTrend(0)
        this.getAndFillDataTrend(1)
      }, 1000)
    },
  },
  mounted() {
    this.getAndFillDataTrend(0)
    this.getAndFillDataTrend(1)

    this.getAndFillDataTrendInterval = setInterval(() => {
      this.getAndFillDataTrend(0)
      this.getAndFillDataTrend(1)
    }, 300000) // 5 minutes
  },
  methods: {
    splidePrev(index) {
      this.$refs['splide'+index][0].go('-1')
    },
    splideNext(index) {
      this.$refs['splide'+index][0].go('+1')
    },
    async getAndFillDataTrend(index) {
      let endpoints = []

      if (this.location === 'PDC') {
        endpoints = [
          'Dashboard/GetDashboardScreenData?screen=TEMPTREND',
          'Dashboard/GetDashboardScreenData?screen=HUMIDTREND'
        ]
      } else {
        endpoints = [
          'Dashboard/GetDashboardScreenData?screen=RACKTEMPPICMOLIVE',
          'Dashboard/GetDashboardScreenData?screen=RACKHUMIDPICMOLIVE'
        ]
      }

      try {
        const res = await this.$axios.get(endpoints[index])
        const lengthPerSlice = 10

        this.terbagiBerapa[index] = Math.ceil(res.data[0]?.ListOfSensor.length / lengthPerSlice)
        let slicedGroupedData = []
        let indexOfTerbagi = 0
        for (let i = 0; i < this.terbagiBerapa[index]; i++) {
          slicedGroupedData.push(res.data[0]?.ListOfSensor.slice(indexOfTerbagi, indexOfTerbagi + lengthPerSlice))
          indexOfTerbagi += lengthPerSlice
        }
        
        this.dataCollectionLineTrends2[index] = []
        slicedGroupedData.forEach(item => {
          const datasets = []
          item.forEach((item, index) => {
            datasets.push({
              label: item.SubDeviceName,
              backgroundColor: this.trendChartColors[index],
              hoverBorderColor: this.trendChartColors[index],
              borderColor: this.trendChartColors[index],
              data: item.HistoricalValue.map((val) => val.DecimalVal),
              fill: false,
              lineTension: 0,
              pointRadius: 1,
              borderWidth: 1
            })
          })
          this.dataCollectionLineTrends2[index].push({
            labels: [...item[0].ListDateTime],
            datasets: [...datasets]
          })
        })

        if (index === 0) {
          this.chartLineTrendVisible0 = false
        } else {
          this.chartLineTrendVisible1 = false
        }

        setTimeout(() => {
          if (index === 0) {
            this.chartLineTrendVisible0 = true
          } else {
            this.chartLineTrendVisible1 = true
          }
        }, 500);
      } catch (err) {
        console.log(err)
      }
    },
    getGridLabel(data) {
      return data?.datasets?.map(x => {
        return {label: x.label, backgroundColor: x.backgroundColor}
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.getAndFillDataTrendInterval)
  }
}
</script>